import React, { Component } from 'react';
import { connect } from 'react-redux';
import EditDealershipSettings from '../../inputs/EditDealershipSettings';

const DEFAULT_DEPARTMENT_SETTINGS = [
	{ name: 'wholesale_car_default_department', label: 'Wholesale Default Department' },
	{ name: 'transit_car_default_department', label: 'In Transit Default Department' },
	{ name: 'prep_car_default_department', label: 'Prep Default Department' },
	{ name: 'new_car_default_department', label: 'New Car Default Department' },
	{ name: 'used_car_default_department', label: 'Used Car Default Department' },
	{ name: 'sold_in_feed_car_default_department', label: 'Sold (Returned in Feed) Default Department' },
	{ name: 'recall_car_default_department', label: 'Recall Car Default Department' },
];

class IncomingStepDefaults extends Component {
	constructor(props) {
		super(props);

		const current = (props.installation && props.installation.subdomain) || props.current_dealership || '';
		this.state = {
			current_default_profile: this.props.current_default_profile,
			errors: { addDepartmentPropertyError: false },
			option_name: '',
			selected_dealership: current,
		};
		this.onChangeDealership = this.onChangeDealership.bind(this);
	}

	componentDidUpdate(prevProps) {
		const current = (this.props.installation && this.props.installation.subdomain) || this.props.current_dealership || '';
		const prevCurrent = (prevProps.installation && prevProps.installation.subdomain) || prevProps.current_dealership || '';
		if (current && current !== prevCurrent && !this.state.selected_dealership) {
			this.setState({ selected_dealership: current });
		}
	}

	onChangeDealership(e) {
		this.setState({ selected_dealership: e.target.value });
	}

	dealershipOptions() {
		const current = (this.props.installation && this.props.installation.subdomain) || this.props.current_dealership || '';
		const related = this.props.related_installations || [];
		const options = [];
		if (current) options.push({ value: current, label: `${current} (current)` });
		related
			.filter(r => r.subdomain && r.subdomain !== current)
			.forEach(r => options.push({ value: r.subdomain, label: r.softname || r.subdomain }));
		return options;
	}

	dealerSettingValue(name) {
		const self = this;
		const settings = self.props.dealer_settings;
		const dealership = self.state.selected_dealership;
		let value = _.sortBy(_.filter(settings, o => o.key === name && o.dealership === dealership), 'id');
		if (value.length === 0) {
			value = _.sortBy(_.filter(settings, o => o.key === name && (o.dealership === '' || o.dealership === null || o.dealership === undefined)), 'id');
		}
		if (value.length > 0) {
			if (typeof value[0] !== 'undefined' && typeof value[0].value !== 'undefined') {
				return value[0].value;
			}
		}
		return '';
	}

	render() {
		const { selected_dealership } = this.state;
		const options = this.dealershipOptions();
		return (
			<div className="sidebar-offcanvas mobile-space-left-2 mobile-pad-left-2 col-md-12">

				<div className="card space-top-0 ">

					<h3 className="text-center pad-top-1">Incoming Step Defaults</h3>

					<div className="card bg-light space-bottom-1 space-top-1 mx-auto w-75 p-3">

						{options.length > 1 && (
							<div className="card-body pad-bottom-0">
								<label className="form-control btn-light pad-right-1 pad-left-1" htmlFor="incoming-step-dealership">Dealership</label>
								<select
									id="incoming-step-dealership"
									className="form-control"
									value={selected_dealership}
									onChange={this.onChangeDealership}
								>
									{options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
								</select>
							</div>
						)}

						<div className="card-body">
							{DEFAULT_DEPARTMENT_SETTINGS.map(setting => (
								<EditDealershipSettings
									{...this.props}
									key={`${setting.name}_${selected_dealership}`}
									type={'select-departments'}
									name={setting.name}
									label={setting.label}
									dealership_override={selected_dealership}
									value={this.dealerSettingValue(setting.name)}
								/>
							))}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		dealer_settings: state.settings_site.dealer_settings,
		installation: state.settings_dealerships.installation,
		current_dealership: state.settings_dealerships.current_dealership,
		related_installations: state.settings_dealerships.related_installations,
	};
}
export default connect(mapStateToProps)(IncomingStepDefaults);
